// @flow
import PropTypes from "prop-types"
import React, {Component} from "react"
import {injectIntl} from "@irati/utils/lang"
import adminTracking from "@irati-tracking/admin"

import CompanySignUpSettings from "../../../../containers/Settings/SignUpSettings"
import SuccessWithBackLink from "../../../SuccessWithBackLink"

class SelfSignUpSettings extends Component {
  static propTypes = {
    updateState: PropTypes.func.isRequired,
    showSelfSignUpSettings: PropTypes.bool.isRequired,
    formatMessage: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      saved: false,
      showSelfSignUpSettings: false,
      message: null
    }
  }

  handleSave = (message) => {
    adminTracking.startEnableSSO()
    this.setState({saved: true, message})
    setTimeout(() => {
      this.setState({saved: false})
      const {updateState} = this.props
      if (updateState) {
        this.props.updateState("showSelfSignUpSettings", false)
      }
    }, 3000)
  }

  render() {
    return this.state.saved ? <SuccessWithBackLink onClick={() => this.setState({saved: false})} message={this.state.message} />
      : <CompanySignUpSettings handleSave={this.handleSave} />
  }
}

export default injectIntl(SelfSignUpSettings)
